module.exports = __webpack_public_path__ + "static/img/stonewall-inn-gives-back-initiative@3x.749d2be.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/pride/stonewall-inn-gives-back-initiative@3x.png
// module id = qbFh
// module chunks = 0